import {
  ArticleIcon,
  BooksIcon,
  BriefcaseIcon,
  CertificateIcon,
  CompassToolIcon,
  GameControllerIcon,
  GraduationCapIcon,
  HandHeartIcon,
  IconProps,
  MedalIcon,
  PuzzlePieceIcon,
  ShareNetworkIcon,
  TranslateIcon,
  UserIcon,
  UsersIcon,
} from "@phosphor-icons/react";
import { defaultSection, SectionKey, SectionWithItem } from "@reactive-resume/schema";
import { Button, ButtonProps, Tooltip } from "@reactive-resume/ui";
import get from "lodash.get";

import { useResumeStore } from "@/client/stores/resume";

export const getSectionIcon = (id: SectionKey, props: IconProps = {}) => {
  switch (id) {
    // Left Sidebar
    case "basics": {
      return <UserIcon size={18} {...props} />;
    }
    case "summary": {
      return <ArticleIcon size={18} {...props} />;
    }
    case "awards": {
      return <MedalIcon size={18} {...props} />;
    }
    case "profiles": {
      return <ShareNetworkIcon size={18} {...props} />;
    }
    case "experience": {
      return <BriefcaseIcon size={18} {...props} />;
    }
    case "education": {
      return <GraduationCapIcon size={18} {...props} />;
    }
    case "certifications": {
      return <CertificateIcon size={18} {...props} />;
    }
    case "interests": {
      return <GameControllerIcon size={18} {...props} />;
    }
    case "languages": {
      return <TranslateIcon size={18} {...props} />;
    }
    case "volunteer": {
      return <HandHeartIcon size={18} {...props} />;
    }
    case "projects": {
      return <PuzzlePieceIcon size={18} {...props} />;
    }
    case "publications": {
      return <BooksIcon size={18} {...props} />;
    }
    case "skills": {
      return <CompassToolIcon size={18} {...props} />;
    }
    case "references": {
      return <UsersIcon size={18} {...props} />;
    }

    default: {
      return null;
    }
  }
};

type SectionIconProps = ButtonProps & {
  id: SectionKey;
  name?: string;
  icon?: React.ReactNode;
};

export const SectionIcon = ({ id, name, icon, ...props }: SectionIconProps) => {
  const section = useResumeStore((state) =>
    get(state.resume.data.sections, id, defaultSection),
  ) as SectionWithItem;

  return (
    <Tooltip side="right" content={name ?? section.name}>
      <Button size="icon" variant="ghost" className="size-8 rounded-full" {...props}>
        {icon ?? getSectionIcon(id, { size: 14 })}
      </Button>
    </Tooltip>
  );
};
